<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text mgr_15">
					Delivery Type
				</em>
				<span class="int_type mgr_15">
					<select v-model="dt_code" class="tbl_select sm_int" @change="selectShipments()">
						<option v-for="dt in sortedDeliveryTypes" v-bind:value="dt.code" v-bind:key="dt.code">{{ dt.name }}</option>
					</select>
				</span>
				<em class="lt_text mgr_15">
					<span
						><b>{{ dt_code }}</b></span
					>
				</em>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_small_tbl">
				<!-- <h4 class="inner_h4">Zone List</h4> -->
				<div class="fixed-table-container">
					<div class="table-wrapper">
						<table class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<th style="text-align:center;width:35%;"><div class="th-text">From</div></th>
									<th style="text-align:center;width:35%;"><div class="th-text">To</div></th>
									<th style="text-align:center;width:30%"><div class="th-text">Zone</div></th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="shipment in shipments"
									v-bind:key="shipment.from_zipcode"
									v-bind:class="{
										on: shipment.delivery_type_code == selectedShipment.delivery_type_code && shipment.from_zipcode == selectedShipment.from_zipcode && shipment.to_zipcode == selectedShipment.to_zipcode,
									}"
									@click="selectRow(shipment)"
								>
									<td>{{ shipment.from_zipcode }}</td>
									<td>{{ shipment.to_zipcode }}</td>
									<td>{{ shipment.zone_code }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ shipments.length | commaSeparated }}</div>

				<div class="view_bottom_bt">
					<a href="javascript:void(0);" :class="mode === 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
				</div>
			</div>

			<div class="right_big_tbl">
				<h4 class="inner_h4">{{ detailTitle }}</h4>
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:100px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>From Zipcode</th>
							<td>
								<input type="text" v-model.trim="shipment.from_zipcode" class="tbl_int sm_int" />
								<span>{{ fromZipcodeInfo }}</span>
							</td>
						</tr>
						<tr>
							<th>To Zipcode</th>
							<td>
								<input type="text" v-model.trim="shipment.to_zipcode" class="tbl_int sm_int" />
								<span>{{ toZipcodeInfo }}</span>
							</td>
						</tr>
						<tr>
							<th>Zone</th>
							<td><input type="text" v-model.trim="shipment.zone_code" class="tbl_int sm_int" maxlength="3" /></td>
						</tr>
					</tbody>
				</table>

				<div class="view_bottom_bt" style="padding-top:15px;">
					<a href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a>
					&nbsp;<a v-if="false" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()">Delete</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectCodeList, apiSelectShipmentList, apiCheckShipmentExists, apiInsertShipment, apiUpdateShipment, apiDeleteShipment } from '@/api/basicinfo/code.js';
import _ from 'lodash';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			backUri: '/',
			dt_code: null,
			mode: null,

			deliveryTypes: [],
			selectedShipment: {},
			shipments: [],
			shipment: {},

			fromZipcodeInfo: null,
			toZipcodeInfo: null,
		};
	},
	computed: {
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		isValid() {
			if (!this.shipment.delivery_type_code || !this.shipment) return false;
			else return true;
		},
		isDeletable() {
			if (this.mode == 'detail' && this.selectedShipment) return true;
			else return false;
		},
		sortedDeliveryTypes() {
			return _.orderBy(this.deliveryTypes, 'name', 'asc'); // 오름차순 :: asc
		},
	},
	watch: {
		shipment: function() {
			//if (oldValue) console.log('data changed from ', oldValue, 'to ', newValue);
			if (this.country_code) this.selectStates();
		},
	},
	components: {},
	methods: {
		async selectDeliveryTypes() {
			const { data } = await apiSelectCodeList({ code_type: 'DT', active_yn: 'Y' });
			this.deliveryTypes = data.codeList;
			if (this.deliveryTypes.length > 0) {
				this.dt_code = this.sortedDeliveryTypes[0].code;
				this.selectShipments();
			} else {
				this.dt_code = null;
			}
		},
		async selectShipments() {
			const { data } = await apiSelectShipmentList({ delivery_type_code: this.dt_code });
			this.shipments = data.shipmentList;
			if (this.shipments.length > 0) {
				this.shipment = this.shipments[0];
				this.selectRow(this.shipment);
			} else {
				this.shipment = {};
			}
			this.mode = 'detail';
		},
		add() {
			this.mode = 'add';
			this.shipment = {};
			this.shipment.delivery_type_code = this.dt_code;
			this.selectedShipment = {};
		},
		async checkExists() {
			const { data } = await apiCheckShipmentExists(this.shipment);
			return data.result;
		},
		async submit() {
			if (!this.shipment.from_zipcode) {
				this.$toast.error('Empty From Zipcode');
				return;
			}
			if (!this.shipment.to_zipcode) {
				this.$toast.error('Empty To Zipcode');
				return;
			}
			if (!this.shipment.zone_code) {
				this.$toast.error('Empty Zone Code');
				return;
			}

			//console.log(this.shipment);
			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Shipment');
					return;
				}
				response = await apiInsertShipment(this.shipment);
			} else {
				response = await apiUpdateShipment(this.shipment);
			}
			var data = response.data;
			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					this.shipments.push(this.shipment);
				}
				// this.setSelectedShipment();
				Object.assign(this.selectedShipment, this.shipment);
			} else {
				this.$toast.error(data.msg);
			}
			this.mode = 'detail';
		},
		// setSelectedShipment() {
		// 	this.selectedShipment.delivery_type_code = this.shipment.delivery_type_code;
		// 	this.selectedShipment.from_zipcode = this.shipment.from_zipcode;
		// 	this.selectedShipment.to_zipcode = this.shipment.to_zipcode;
		// 	this.selectedShipment.zone_code = this.shipment.zone_code;
		// },
		async del() {
			if (!this.isDeletable) return;
			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteShipment(this.shipment);
				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.selectShipments();
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		selectRow(shipment) {
			this.mode = 'detail';
			this.selectedShipment = shipment;

			this.shipment = _.cloneDeep(shipment);
		},
	},
	created() {
		this.backUri = '/';

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_shipment');
		this.$store.commit('setSubTitle', 'Basic Information -> Shipment');

		this.selectDeliveryTypes();
		//this.country_code = 'US';
		//this.selectZipcodes();
	},
	mounted() {
		inputSelectOnClick();

		$('.table-wrapper').on('scroll', function() {
			if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
				//var $rows = $('#item_list tbody tr');
				var $rows = $('.list_table tbody tr');
				var lastActiveIndex = $rows.filter('.active:last').index();
				$rows.filter(':lt(' + (lastActiveIndex + 25) + ')').addClass('active');
			}
		});
	},
};
</script>

<style></style>
